"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Modal = _interopRequireDefault(require("./Modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useNode = () => {
  const [node, setNode] = (0, _react.useState)(null);
  const ref = (0, _react.useCallback)(node => {
    if (node !== null) {
      setNode(node);
    }
  }, []);
  return [node, ref];
};

const arrowSize = 16;

const Arrow = _styledComponents.default.div.withConfig({
  displayName: "AttachedModal__Arrow",
  componentId: "sc-1t4gh5f-0"
})(["position:absolute;left:", "px;top:", "px;border:", "px solid transparent;border-bottom-color:#fff;"], p => p.left, p => p.top, arrowSize / 2);

const AttachWrapper = _styledComponents.default.div.withConfig({
  displayName: "AttachedModal__AttachWrapper",
  componentId: "sc-1t4gh5f-1"
})(["position:relative;", ";"], p => p.show && (0, _styledComponents.css)(["z-index:2;"]));

const AttachedModal = ({
  className,
  show: initShow,
  onShow = () => {},
  onClose = () => {},
  attachToEl,
  width = 320,
  margin = 8,
  children
}) => {
  const [attachToNode, attachToRef] = useNode();
  const [show, setShow] = (0, _react.useState)(initShow);
  const [modalPosition, setModalPosition] = (0, _react.useState)({});
  const [arrowPosition, setArrowPosition] = (0, _react.useState)({});
  const [delayTimer, setDelayTimer] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    setShow(initShow);
  }, [initShow]);
  (0, _react.useEffect)(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [show, delayTimer]);
  (0, _react.useEffect)(() => {
    calculatePos();
  }, [show, attachToNode]);
  (0, _react.useEffect)(() => {
    if (!show) {
      return;
    }

    onShow();
  }, [show]);

  const handleResize = () => {
    if (!show) {
      return;
    }

    if (delayTimer) {
      clearTimeout(delayTimer);
    }

    const timer = setTimeout(calculatePos, 500);
    setDelayTimer(timer);
  };

  const calculatePos = () => {
    if (!show || !attachToNode) {
      return;
    }

    if (!attachToNode.hasChildNodes()) {
      return;
    }

    const firstChild = attachToNode.children[0];
    const rect = firstChild.getBoundingClientRect();
    const refElOffset = getOffset(firstChild);
    let left = refElOffset.left - Math.abs(width - rect.width) / 2;

    if (left < margin) {
      left = margin;
    } else if (left + width + margin > document.documentElement.clientWidth) {
      left = document.documentElement.clientWidth - width - margin;
    }

    const modalPosition = {
      top: refElOffset.top + rect.height + margin + arrowSize / 2,
      left
    };
    setModalPosition(modalPosition);
    const arrowPosition = {
      left: Math.abs(refElOffset.left - modalPosition.left) + rect.width / 2 - arrowSize / 2,
      top: -arrowSize
    };
    setArrowPosition(arrowPosition);
  };

  function getOffset(el) {
    let x = 0;
    let y = 0;

    while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
      x += el.offsetLeft - el.scrollLeft;
      y += el.offsetTop - el.scrollTop;
      el = el.offsetParent;
    }

    return {
      top: y,
      left: x
    };
  }

  const toggleShow = () => {
    setShow(!show);
  };

  const hideModal = () => {
    setShow(false);
    onClose();
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(AttachWrapper, {
    show: show,
    ref: attachToRef,
    onClick: toggleShow
  }, attachToEl), /*#__PURE__*/_react.default.createElement(_Modal.default, {
    show: show,
    attachToBody: true,
    onClose: hideModal,
    top: modalPosition.top,
    left: modalPosition.left,
    width: width
  }, /*#__PURE__*/_react.default.createElement(Arrow, {
    left: arrowPosition.left,
    top: arrowPosition.top
  }), children));
};

var _default = (0, _styledComponents.default)(AttachedModal).withConfig({
  displayName: "AttachedModal",
  componentId: "sc-1t4gh5f-2"
})([""]);

exports.default = _default;